import { Container } from 'reactstrap';
import HistoricalChangeCollection from './HistoricalChangeCollection';

const HistorySection = ({
    heading,
    historicalChangeCollection,
    propertiesToIgnore,
    renderOptions,
}) => (
    <Container
        tag="section"
        fluid
        className="px-0 mb-4"
        aria-label={heading}
    >
        <HistoricalChangeCollection
            heading={heading}
            historicalChangeCollection={historicalChangeCollection}
            propertiesToIgnore={propertiesToIgnore}
            renderOptions={renderOptions}
        />
    </Container>
);

export default HistorySection;
